<button class="button transparent dropdown text-left" style="max-width: 200px;" [attr.data-toggle]="dataToggle">
  <span class="c-white-inversed c-primary">
    <b>{{label}}</b>
  </span>
  <small class="c-white-inversed c-primary container-ellipsis" style="display:block;">
    <span class="flag-icon flag-icon-us"></span>
    {{getSelectedValues()}}
  </small>
</button>
